<template>
  <div id="container" style="width: 100%; height: 100%"></div>
</template>

<script>
// import apis from '@/utils/apis';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import Cookies from 'js-cookie';

var map;
var showInfoWindow;
var pi = 3.14159265358979324;
var a = 6378245.0;
var ee = 0.00669342162296594323;
var languageMap = {
  // langcode映射谷歌地图language
  CN: 'zh-CN',
  EN: 'en-hk',
};
// device_map_wei_zhi_di_zhi: 未知地址

export default {
  name: 'device_map',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    formSearch: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    list() {
      this.initMap();
    },
  },
  data() {
    return {
      mapType: '', // 1-高德   4-谷歌
      mapRegion: '', // 谷歌地图 本地化区域
      mapLanguage: '', // 谷歌地图 地图多语言,
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_device_map');
    const langCode = Cookies.get('langCode') || 'CN';
    this.mapLanguage = languageMap[langCode];
    this.mapType = Cookies.get('mapType') || '1';
    this.mapRegion = Cookies.get('mapRegion') || 'HK';
    this.initMap();
  },
  methods: {
    transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) * 2.0) / 3.0;
      return ret;
    },
    transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) * 2.0) / 3.0;
      return ret;
    },
    outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    },
    // 国际坐标=>中国坐标
    wgs_gcj_encrypts: function (wgLat, wgLon) {
      var point = {};
      if (this.outOfChina(wgLat, wgLon)) {
        point.lat = wgLat;
        point.lng = wgLon;
        return point;
      }
      var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
      var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
      var radLat = (wgLat / 180.0) * pi;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
      var lat = wgLat + dLat;
      var lon = wgLon + dLon;
      point.lat = lat;
      point.lon = lon;
      return point;
    },
    // 初始化地图
    initMap: function () {
      if (`${this.mapType}` === '4') {
        this.inintGoogleMap(() => {
          this.initDeviceGMap(this.list);
        });
      } else if (`${this.mapType}` === '1') {
        this.initAMap(() => {
          this.initDeviceAMap(this.list);
        });
      }
    },
    // 初始化(高德地图)
    initAMap: function (cb) {
      cb = cb || function () {};
      const { center, zoom } = this.$getAMapCenterZoom();
      if (window.AMap) {
        map = new window.AMap.Map('container', { center, zoom, mapStyle: 'amap://styles/whitesmoke' });
        cb();
        return;
      }
      this.$loadJS('https://webapi.amap.com/maps?v=2.0&key=ec6dcb4fc6e239c1834a5fbdceb9ce7e', () => {
        map = new window.AMap.Map('container', { center, zoom, mapStyle: 'amap://styles/whitesmoke' });
        cb();
      });
    },
    // 初始化(谷歌地图)
    inintGoogleMap: function (cb) {
      cb = cb || function () {};
      const { center, zoom } = this.$getGMapCenterZoom();
      if (window.google) {
        map = new window.google.maps.Map(document.getElementById('container'), { zoom, center, mapTypeId: 'roadmap' });
        cb();
        return;
      }
      this.$loadJS(`https://maps.googleapis.com/maps/api/js?key=AIzaSyCFJUNQ5om8G9WFr0TYMx4mA6-Gx7UiOYA&region=${this.mapRegion}&language=${this.mapLanguage}`, ({ google }) => {
        map = new google.maps.Map(document.getElementById('container'), { zoom, center, mapTypeId: 'roadmap' });
        cb();
      });
    },
    // 渲染设备(高德地图)
    initDeviceAMap: function (points) {
      const _this = this;
      points = points.filter(t => t.lat && t.lng);
      points.forEach((item) => {
        const point = this.wgs_gcj_encrypts(item.lat, item.lng);
        item.lnglat = [point.lon, point.lat];
      });
      // 自定义非聚合点样式
      var _renderMarker = function (context) {
        var content = '<div class="map-marker"><div class="marker-img"></div><div class="marker"></div></div>';
        var offset = new window.AMap.Pixel(-6, -6);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        const item = context.data[0];
        context.marker.on('click', () => {
          _this.openInfoWindow(item);
        });
      };
      // 自定义聚合点样式
      var _renderClusterMarker = function (context) {
        var clusterCount = context.count; // 聚合中点个数
        var content = `<div class="map-cluster-marker"><div class="marker"><div class="marker-num">${clusterCount}</div></div><div class="marker-block"></div></div>`;
        var offset = new window.AMap.Pixel(-18, -18);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
      };
      map.plugin(['AMap.MarkerCluster'], () => {
        const markerCluster = new window.AMap.MarkerCluster(map, points, {
          gridSize: 60, // 聚合网格像素大小
          renderMarker: _renderMarker, // 自定义非聚合点样式
          renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        });
        return markerCluster;
      });
    },
    // 打开弹窗(高德地图)
    openInfoWindow: async function (item) {
      if (!item.location) {
        item.location = (await this.getGeoCode(item.lnglat).catch(() => {})) || this.$t('device_map_wei_zhi_di_zhi');
      }
      const infoWindow = new window.AMap.InfoWindow({
        offset: new window.AMap.Pixel(0, -10),
        content: `<div class='product'>
          <div class='ub'>
            <div class='img-box'>
              <img src='${item.attachUrl || item.attachPath}' alt />
            </div>
            <div class='info'>
              <h1>${item.bodyNum}</h1>
              <p>${item.productCode} ${item.deviceName} ${!this.formSearch.locationId && item.locationName ? item.locationName : ''} ${this.formSearch.locationId && item.siteName ? item.siteName : ''}
              </p>
              <div class="about">
                <span>
                  <i class="icon icon-battery-percent-75"></i>
                  ${item.batteryCharge ? `${item.batteryCharge}%` : '-'}
                </span>
                <span>
                  <i class="icon icon-signal"></i>
                   ${item.signal ? `${item.signal}%` : '-'}
                </span>
                <span>
                  <i class="icon icon-temperature"></i>
                   ${item.batteryTemp ? `${item.batteryTemp}%` : '-'}
                </span>
              </div>
            </div>
          </div>
          <div class="ub loc-wrap">
            <div class="icon-loc">
              <i class="icon icon-location"></i>
            </div>
            <div class="location"><div>${item.location}</div></div>
          </div>
        </div>`,
      });
      // showInfoWindow = infoWindow;
      infoWindow.open(map, item.lnglat);
    },
    // 逆地理编码(高德单个)
    getGeoCode: async function (lnglat) {
      return new Promise((resolve, reject) => {
        if (!lnglat) {
          reject();
          return;
        }
        window.AMap.plugin('AMap.Geocoder', () => {
          const Geocoder = new window.AMap.Geocoder();
          Geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              resolve(result.regeocode.formattedAddress);
            } else {
              reject();
            }
          });
        });
      });
    },
    // 渲染设备（谷歌地图）
    initDeviceGMap: function (points) {
      const _this = this;
      points = points.filter(t => t.lat && t.lng);
      const markers = points.map((point) => {
        let position;
        // 国内/香港/澳门需要做坐标转换
        if (this.mapRegion === 'HK' || this.mapRegion === 'CN' || this.mapRegion === 'MO') {
          const wgs = this.wgs_gcj_encrypts(point.lat, point.lng);
          position = { lat: wgs.lat, lng: wgs.lon };
        } else {
          position = { lat: point.lat, lng: point.lng };
        }
        const marker = new window.google.maps.Marker({
          position: position,
          icon: {
            url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/WechatIMG406 2.png',
            scaledSize: new window.google.maps.Size(41, 58),
          },
        });
        point.marker = marker;
        marker.addListener('click', () => {
          _this.openGoogleInfoWindow(point, marker);
        });
        return marker;
      });
      const markerCluster = new MarkerClusterer(map, markers, {
        clusterClass: 'map-cluster-g-marker',
        origin: new window.google.maps.Point(0, -30),
        anchor: new window.google.maps.Point(0, -26),
        styles: [
          MarkerClusterer.withDefaultStyle({
            width: 18,
            height: 34,
            textColor: '#ffffff',
            textSize: 10,
            textLineHeight: 26,
            textAlign: 'center',
          }),
        ],
      });
      console.warn(markerCluster);
    },
    // 打开弹窗(谷歌地图)
    openGoogleInfoWindow: async function (item, marker) {
      if (showInfoWindow && showInfoWindow.close) {
        showInfoWindow.close();
      }
      if (!item.location) {
        item.location = (await this.getGoogleCode(item).catch(() => {})) || 'Unknown address';
      }
      const infoWindow = new window.google.maps.InfoWindow({
        pixelOffset: { height: 44 },
        content: `<div class='product'>
          <div class='ub'>
            <div class='img-box'>
              <img src='${item.attachUrl || item.attachPath}' alt />
            </div>
            <div class='info'>
              <h1>${item.bodyNum}</h1>
               <p>${item.productCode} ${item.deviceName} ${!this.formSearch.locationId && item.locationName ? item.locationName : ''} ${
  this.formSearch.locationId && item.siteName ? item.siteName : ''
}</p>
              <div class="about">
                <span>
                  <i class="icon icon-battery-percent-75"></i>
                  ${item.batteryCharge ? `${item.batteryCharge}%` : '--'}
                </span>
                <span>
                  <i class="icon icon-signal"></i>
                   ${item.signal ? `${item.signal}%` : '--'}
                </span>
                <span>
                  <i class="icon icon-temperature"></i>
                   ${item.batteryTemp ? `${item.batteryTemp}%` : '--'}
                </span>
              </div>
            </div>
          </div>
          <div class="ub loc-wrap">
             <div class="icon-loc">
              <i class="icon icon-location"></i>
            </div>
            <div class="location"><div>${item.location}</div></div>
          </div>
        </div>`,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, marker);
    },
    // 逆地理编码(谷歌、单个)
    getGoogleCode: async function (item) {
      return new Promise((resolve, reject) => {
        if (!item.lat || !item.lng) {
          reject();
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: new window.google.maps.LatLng(item.lat, item.lng) }, (results, status) => {
          // 这里处理结果和上面一模一样
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0].formatted_address);
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.map-marker {
  .marker {
    margin: 0 auto;
    width: 12px;
    height: 12px;
    background: #0d9ae0;
    border: 2px solid #ffffff;
    border-radius: 6px;
  }
}

.map-cluster-marker {
  .marker .marker-num {
    background-color: #ffad00;
    width: 36px;
    height: 36px;
    line-height: 34px;
    border-radius: 36px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    border: 2px solid #ffffff;
  }
}

.map-cluster-g-marker {
  background: #0c89c7;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  padding: 4px 14px;
  border-radius: 8px;
  width: auto !important;
  transform: translateY(-20px);
  & > div {
    min-width: 18px;
    position: relative !important;
    width: auto !important;
    &:active,
    &:visited,
    &:hover {
      border: none;
      outline: none;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 33px;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top: 6px solid #0c89c7;
    width: 0;
    height: 0px;
  }
  &::before {
    content: '';
    width: 32px;
    height: 14px;
    background-image: url('../../../images/map/block.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.product {
  width: 246px;
  padding-bottom: 40px;
  .img-box {
    width: 60px;
    height: 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    padding-left: 12px;
    h1 {
      color: #4d4d4d;
      line-height: 17px;
      font-size: 14px;
      margin-bottom: 4px;
      font-weight: 500;
    }
    p {
      line-height: 16px;
      font-size: 12px;
      color: #6c757d;
      margin-bottom: 5px;
    }
  }
  .about {
    font-size: 0;
    span {
      color: #4d4d4d;
      font-size: 12px;
      margin-right: 2px;
      display: inline-block;
      line-height: 17px;
      width: 48px;
    }
    .icon {
      color: #12c469;
      font-size: 14px;
      margin-right: 2px;
    }
  }
  .loc-wrap {
    height: 40px;
    background: #f5f5f5;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 6px 12px;
    .icon-loc {
      width: 18px;
      height: 18px;
      overflow: hidden;
      margin-right: 6px;
      margin-top: 2px;
      i {
        font-size: 17px;
        color: #0d9ae0;
      }
    }
    .location {
      flex: 1;
      width: 0;
      color: #6c757d;
      line-height: 14px;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
